import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/apply-avatar.jpg'
import _imports_1 from '@/assets/images/apply-poster.jpg'


const _withScopeId = n => (_pushScopeId("data-v-b9141f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-apply" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_1', 'text_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_1', 'text_2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_1', 'text_3')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_1', 'text_4')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_1', 'caution_1')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_LinkButton, {
            href: "https://forms.gle/Mn3XF1LmuBXMuugt8",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('button_submit')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_1, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_2', 'title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'text_1')), 1),
          _hoisted_2,
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_2', 'heading_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'text_2')), 1),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_2', 'heading_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'text_3')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_2', 'caution_1')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_2', 'heading_3')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'li_1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'li_2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'li_3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'li_4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'li_5')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'li_6')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'li_7')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_2', 'li_8')), 1)
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_2', 'caution_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_2', 'caution_3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_LinkButton, {
            href: "https://forms.gle/Mn3XF1LmuBXMuugt8",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('button_submit')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", null, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_3', 'title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'text_1')), 1),
          _hoisted_3,
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_3', 'heading_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'text_2')), 1),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_3', 'heading_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'text_3')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_3', 'caution_1')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_3', 'heading_3')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'li_1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'li_2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'li_3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'li_4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'li_5')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('section_3', 'li_6')), 1)
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_3', 'caution_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_3', 'caution_3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('section_3', 'caution_4')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_LinkButton, {
            href: "https://forms.gle/Mn3XF1LmuBXMuugt8",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('button_submit')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}